/* chunq — global.js
   Vanilla JS only. Live clock, AJAX cart + drawer, product form, quantity steppers. */

(function () {
  'use strict';

  /* ---------- live clock ---------- */
  function startClocks() {
    var clocks = document.querySelectorAll('[data-clock]');
    if (!clocks.length) return;

    function tick() {
      clocks.forEach(function (el) {
        var tz = el.getAttribute('data-clock-tz') || 'America/New_York';
        var label = el.getAttribute('data-clock-label') || '';
        var now = new Date();
        var parts;
        try {
          parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          }).formatToParts(now);
        } catch (e) {
          return;
        }
        var p = {};
        parts.forEach(function (part) {
          p[part.type] = part.value;
        });
        var ampm = (p.dayPeriod || '').toLowerCase();
        el.textContent =
          p.month + '/' + p.day + '/' + p.year + ' ' + p.hour + ':' + p.minute + ':' + p.second + ampm + (label ? ' ' + label : '');
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- countdown ---------- */
  function startCountdowns() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      els.forEach(function (el) {
        var target = new Date(el.getAttribute('data-countdown')).getTime();
        if (isNaN(target)) return;
        var diff = target - Date.now();
        if (diff <= 0) {
          el.textContent = el.getAttribute('data-countdown-done') || '00:00:00';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- cart helpers ---------- */
  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function updateCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute('data-cart-empty', cart.item_count === 0);
    });
  }

  function refreshDrawer(openAfter) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer .drawer__panel');
        var current = drawer.querySelector('.drawer__panel');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        if (openAfter) drawer.open();
        if (drawer.querySelector('[data-chunq-checkout-form]')) {
          ensureOrderReference(drawer).catch(function () {
            /* Checkout can continue; the order webhook provides the fallback. */
          });
        }
      })
      .catch(function () {});
  }

  /* ---------- chunq order reference ----------
     A private-by-convention cart attribute becomes the permanent customer
     reference after Shopify creates the order. Shopify's internal order name
     remains unchanged for admin, fulfillment, and integrations. */
  var CHUNQ_REFERENCE_KEY = '_chunq_reference';
  var CHUNQ_REFERENCE_ALPHABET = 'ABCDEFGHJKMNPQRSTVWXYZ23456789';
  var CHUNQ_REFERENCE_PATTERN = /^CHQ-[ABCDEFGHJKMNPQRSTVWXYZ23456789]{10}$/;

  function normalizeOrderReference(value) {
    if (typeof value !== 'string') return '';
    var reference = value.trim().toUpperCase();
    return CHUNQ_REFERENCE_PATTERN.test(reference) ? reference : '';
  }

  function generateOrderReference() {
    if (!window.crypto || !window.crypto.getRandomValues) {
      throw new Error('secure random values unavailable');
    }

    var body = '';
    var limit = 256 - (256 % CHUNQ_REFERENCE_ALPHABET.length);
    while (body.length < 10) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      for (var index = 0; index < bytes.length && body.length < 10; index += 1) {
        if (bytes[index] >= limit) continue;
        body += CHUNQ_REFERENCE_ALPHABET.charAt(
          bytes[index] % CHUNQ_REFERENCE_ALPHABET.length
        );
      }
    }
    return 'CHQ-' + body;
  }

  function updateReferenceInputs(reference) {
    document
      .querySelectorAll('input[name="attributes[' + CHUNQ_REFERENCE_KEY + ']"]')
      .forEach(function (input) {
        input.value = reference;
      });
  }

  function ensureOrderReference(form) {
    var input = form.querySelector(
      'input[name="attributes[' + CHUNQ_REFERENCE_KEY + ']"]'
    );
    var reference = normalizeOrderReference(input ? input.value : '');
    if (reference) {
      updateReferenceInputs(reference);
      return Promise.resolve(reference);
    }

    reference = generateOrderReference();
    updateReferenceInputs(reference);

    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { _chunq_reference: reference },
      }),
    }).then(function () {
      return reference;
    });
  }

  function submitCheckoutForm(form, submitter) {
    form.setAttribute('data-chunq-reference-ready', 'true');
    if (form.requestSubmit && submitter) {
      form.requestSubmit(submitter);
      return;
    }

    var checkout = form.querySelector('input[data-chunq-checkout-fallback]');
    if (!checkout) {
      checkout = document.createElement('input');
      checkout.type = 'hidden';
      checkout.name = 'checkout';
      checkout.value = 'checkout';
      checkout.setAttribute('data-chunq-checkout-fallback', '');
      form.appendChild(checkout);
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function initOrderReferences() {
    document.addEventListener('submit', function (evt) {
      var form = evt.target.closest('[data-chunq-checkout-form]');
      if (!form || form.getAttribute('data-chunq-reference-ready') === 'true') {
        return;
      }

      var existingInput = form.querySelector(
        'input[name="attributes[' + CHUNQ_REFERENCE_KEY + ']"]'
      );
      if (normalizeOrderReference(existingInput ? existingInput.value : '')) {
        return;
      }

      evt.preventDefault();
      var submitter = evt.submitter;
      var button =
        submitter || form.querySelector('button[type="submit"][name="checkout"]');
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'preparing secure checkout...';
      }

      ensureOrderReference(form)
        .catch(function () {
          /* The order webhook supplies a reference if the cart update fails. */
        })
        .then(function () {
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
          submitCheckoutForm(form, submitter);
        });
    });
  }

  window.chunqCart = {
    add: function (formData) {
      return fetchJSON('/cart/add.js', { method: 'POST', body: formData })
        .then(function () {
          return fetchJSON('/cart.js');
        })
        .then(function (cart) {
          updateCartCounts(cart);
          /*
           * Launch-safe purchase path: after Shopify confirms the selected
           * variant was added, go straight to Shopify's native checkout.
           * This avoids the fragile drawer express-payment layer and keeps
           * shipping, addresses, wallets, taxes, and payment handling inside
           * the checkout Shopify owns.
           */
          window.location.assign('/checkout');
          return cart;
        });
    },
    change: function (key, quantity) {
      return fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then(function (cart) {
        updateCartCounts(cart);
        return cart;
      });
    },
  };

  /* ---------- <product-form> ---------- */
  var ProductForm = (function () {
    function init(el) {
      var form = el.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var button = form.querySelector('[data-add-button]');
      var errorBox = el.querySelector('[data-form-error]');

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (button && button.disabled) return;
        var original = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = button.getAttribute('data-adding-text') || 'adding...';
        }
        if (errorBox) errorBox.hidden = true;

        window.chunqCart
          .add(new FormData(form))
          .then(function () {
            if (button) {
              button.textContent = button.getAttribute('data-added-text') || 'added';
              setTimeout(function () {
                button.disabled = false;
                button.textContent = original;
              }, 1200);
            }
          })
          .catch(function (err) {
            if (button) {
              button.disabled = false;
              button.textContent = original;
            }
            if (errorBox) {
              errorBox.textContent = (err && (err.description || err.message)) || 'could not add to cart';
              errorBox.hidden = false;
            }
          });
      });
    }
    return { init: init };
  })();

  /* ---------- <variant-selects> ----------
     Reads variant data from an embedded JSON script tag. On option change,
     finds the matching variant, updates price/availability/button/url. */
  var VariantSelects = (function () {
    function init(el) {
      var dataEl = el.querySelector('[data-variant-json]');
      var productEl = el.closest('[data-product]');
      if (!dataEl || !productEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var optionGroups = el.querySelectorAll('[data-option-group]');
      var optionInputs = el.querySelectorAll('[data-option-input]');
      var idInput = productEl.querySelector('input[name="id"]');
      var button = productEl.querySelector('[data-add-button]');
      var priceEl = productEl.querySelector('[data-product-price]');
      var stockEl = productEl.querySelector('[data-stock-status]');
      var waitlistEl = productEl.querySelector('[data-waitlist-form]');
      var galleryEl = productEl.querySelector('[data-product-gallery]');
      var stickyButton = productEl.querySelector('[data-sticky-add]');
      var stickyPrice = productEl.querySelector('[data-sticky-price]');
      var stickyVariant = productEl.querySelector('[data-sticky-variant]');

      function currentOptions() {
        return Array.prototype.map.call(optionGroups, function (group) {
          var selected = group.querySelector('[data-option-input]:checked');
          return selected ? selected.value : '';
        });
      }

      function money(cents) {
        var format = window.chunqMoneyFormat || '${{amount}}';
        var amount = (cents / 100).toFixed(2);
        if (/amount_no_decimals/.test(format)) amount = Math.round(cents / 100).toString();
        if (/with_comma_separator/.test(format)) amount = amount.replace('.', ',');
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
      }

      function selectMedia(mediaId) {
        if (!galleryEl || !mediaId) return;
        var mediaItems = galleryEl.querySelectorAll('[data-product-media-id]');
        var selected = null;
        mediaItems.forEach(function (item) {
          var isSelected = item.getAttribute('data-product-media-id') === String(mediaId);
          item.classList.toggle('is-selected', isSelected);
          if (isSelected) selected = item;
        });
        if (selected && window.matchMedia('(max-width: 749px)').matches) {
          galleryEl.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }

      function updateAvailability(match) {
        if (stockEl) {
          var availableText = stockEl.getAttribute('data-available-text') || 'available';
          var lowStockText = stockEl.getAttribute('data-low-stock-text') || 'only [count] left';
          var soldOutText = stockEl.getAttribute('data-sold-out-text') || 'sold out';
          if (!match.available) {
            stockEl.textContent = soldOutText;
            stockEl.classList.add('is-sold-out');
          } else if (match.inventoryManagement && match.inventoryQuantity > 0 && match.inventoryQuantity <= 3) {
            stockEl.textContent = lowStockText.replace('[count]', match.inventoryQuantity);
            stockEl.classList.remove('is-sold-out');
          } else {
            stockEl.textContent = availableText;
            stockEl.classList.remove('is-sold-out');
          }
        }
        if (waitlistEl) waitlistEl.hidden = match.available;
      }

      function onChange() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === opts[i];
          });
        });

        if (!match) {
          if (button) {
            button.disabled = true;
            button.textContent = 'unavailable';
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        if (priceEl) priceEl.innerHTML = money(match.price);
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (stickyVariant) stickyVariant.textContent = match.title;

        if (button) {
          if (match.available) {
            button.disabled = false;
            button.textContent = button.getAttribute('data-add-text') || 'add to cart';
          } else {
            button.disabled = true;
            button.textContent = 'sold out';
          }
        }

        if (stickyButton) {
          stickyButton.disabled = !match.available;
          stickyButton.textContent = match.available
            ? (button && button.getAttribute('data-add-text')) || 'add to cart'
            : 'sold out';
        }

        updateAvailability(match);
        selectMedia(match.featuredMediaId);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', onChange);
      });
      if (stickyButton && button) {
        stickyButton.addEventListener('click', function () {
          if (!stickyButton.disabled) button.click();
        });
      }
      onChange();
    }
    return { init: init };
  })();

  function changeCartLine(root, button, reloadPage) {
    if (root.getAttribute('aria-busy') === 'true') return;
    var key = button.getAttribute('data-line-key');
    if (!key) return;
    var quantity = parseInt(button.getAttribute('data-quantity'), 10);
    var error = root.querySelector('[data-cart-error]');
    if (error) error.hidden = true;
    root.setAttribute('aria-busy', 'true');
    root.querySelectorAll('[data-line-change]').forEach(function (control) { control.disabled = true; });
    function unlock() {
      root.removeAttribute('aria-busy');
      root.querySelectorAll('[data-line-change]').forEach(function (control) { control.disabled = false; });
    }
    window.chunqCart.change(key, quantity).then(function () {
      if (reloadPage) {
        window.location.reload();
        return;
      }
      return refreshDrawer(true).then(unlock);
    }).catch(function () {
      unlock();
      if (error) error.hidden = false;
    });
  }

  /* ---------- <cart-drawer> ---------- */
  function defineDrawer() {
    if (customElements.get('cart-drawer')) return;

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (evt) {
          if (evt.target.closest('[data-drawer-close]') || evt.target === self.querySelector('.drawer__scrim')) {
            self.close();
          }
          var lineBtn = evt.target.closest('[data-line-change]');
          if (lineBtn) {
            evt.preventDefault();
            changeCartLine(self, lineBtn, false);
          }
        });
        document.addEventListener('keydown', function (evt) {
          if (evt.key === 'Escape') self.close();
        });
      }
      open() {
        this.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        var panel = this.querySelector('.drawer__panel');
        if (panel) panel.focus();
      }
      close() {
        this.removeAttribute('open');
        document.documentElement.style.overflow = '';
      }
    }
    customElements.define('cart-drawer', CartDrawer);
  }

  /* ---------- cart page quantity ---------- */
  function initCartPage() {
    var cartRoot = document.querySelector('[data-cart-page]');
    if (!cartRoot) return;

    cartRoot.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-line-change]');
      if (!btn) return;
      evt.preventDefault();
      changeCartLine(cartRoot, btn, true);
    });
  }

  /* ---------- header cart icon opens drawer ---------- */
  function initCartLink() {
    document.addEventListener('click', function (evt) {
      var link = evt.target.closest('[data-cart-open]');
      if (!link) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      evt.preventDefault();
      refreshDrawer(true);
    });
  }

  function startFittedRelease() {
    var nodes = Array.from(document.querySelectorAll('[data-fitted-release]'));
    if (!nodes.length) return;
    var deadline = Date.parse(nodes[0].getAttribute('data-release-at'));
    var endpoint = nodes[0].getAttribute('data-release-url') + '.js';
    var serverBase = null;
    var localBase = performance.now();
    var inFlight = false;
    var nextCheck = 0;
    var failures = 0;
    var reloading = false;
    function now() { return serverBase === null ? Date.now() : serverBase + performance.now() - localBase; }
    function draw() {
      var remaining = Math.max(0, Math.ceil((deadline - now()) / 1000));
      var clock = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(function(n) { return String(n).padStart(2, '0'); }).join(':');
      nodes.forEach(function(node) {
        var text = remaining ? clock : node.getAttribute('data-release-waiting');
        node.querySelectorAll('[data-release-countdown]').forEach(function(el) { el.textContent = text; });
      });
      if (!remaining && performance.now() >= nextCheck) check();
    }
    async function check() {
      if (inFlight || reloading) return;
      inFlight = true;
      try {
        var response = await fetch(endpoint + '?release_check=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
        if (!response.ok) throw new Error('Release status unavailable');
        var serverDate = Date.parse(response.headers.get('Date'));
        if (Number.isFinite(serverDate)) { serverBase = serverDate; localBase = performance.now(); }
        var product = await response.json();
        failures = 0;
        if (now() >= deadline && product.available === true) {
          reloading = true;
          var url = new URL(window.location.href);
          url.searchParams.set('release', String(Date.now()));
          window.location.replace(url.toString());
          return;
        }
        nextCheck = performance.now() + Math.max(5000, deadline - now());
      } catch (error) {
        failures += 1;
        nextCheck = performance.now() + Math.min(60000, 5000 * Math.pow(2, failures));
      } finally { inFlight = false; }
    }
    draw();
    check();
    window.setInterval(draw, 1000);
    document.addEventListener('visibilitychange', function() { if (!document.hidden) { nextCheck = 0; draw(); } });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    startClocks();
    startCountdowns();
    startFittedRelease();
    defineDrawer();
    initCartPage();
    initCartLink();
    initOrderReferences();
    if (document.querySelector('[data-chunq-checkout-form]')) {
      ensureOrderReference(document).catch(function () {
        /* Checkout can continue; the order webhook provides the fallback. */
      });
    }
    document.querySelectorAll('[data-product-form]').forEach(ProductForm.init);
    document.querySelectorAll('[data-variant-selects]').forEach(VariantSelects.init);
  });
})();


/* Inline campaign films: respect motion preferences and pause out of view. */
(function () {
  function initFilms(root) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var saveData = navigator.connection && navigator.connection.saveData;
    root.querySelectorAll('[data-chunq-film]').forEach(function (frame) {
      if (frame.dataset.filmReady) return;
      frame.dataset.filmReady = 'true';
      var video = frame.querySelector('video');
      var button = frame.querySelector('[data-film-toggle]');
      if (!video) return;
      var automatic = frame.hasAttribute('data-film-autoplay');
      var manuallyPaused = false;
      var visible = false;
      function updateButton() {
        if (button) button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }
      function play() { var attempt = video.play(); if (attempt) attempt.catch(updateButton); }
      if (button) {
        button.hidden = false;
        video.controls = false;
        button.addEventListener('click', function () {
          if (video.paused) { manuallyPaused = false; play(); }
          else { manuallyPaused = true; video.pause(); }
        });
      }
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('error', function () { if (button) button.hidden = true; });
      function maybePlay() {
        if (automatic && visible && !document.hidden && !reduced.matches && !saveData && !manuallyPaused) play();
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (!visible) video.pause(); else maybePlay();
        }, { threshold: 0.25 });
        observer.observe(frame);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) video.pause(); else maybePlay(); });
      reduced.addEventListener('change', function () { if (reduced.matches) video.pause(); else maybePlay(); });
      updateButton();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initFilms(document); });
  else initFilms(document);
  document.addEventListener('shopify:section:load', function (event) { initFilms(event.target); });
})();
